import { useIsDarkMode } from '@chronosphereio/chrono-ui';
import constate from 'constate';
import { useRef } from 'react';
import { DARK_COLOR_PALETTE, LIGHT_COLOR_PALETTE, SeriesColorGenerator } from '../../core/utils/color';

function useSeriesColorGeneratorInternal() {
  const lightSeriesGenerator = useRef(
    new SeriesColorGenerator({
      palette: LIGHT_COLOR_PALETTE,
    })
  );
  const darkSeriesGenerator = useRef(
    new SeriesColorGenerator({
      palette: DARK_COLOR_PALETTE,
    })
  );

  const isDarkMode = useIsDarkMode();
  if (isDarkMode) {
    return darkSeriesGenerator.current;
  } else {
    return lightSeriesGenerator.current;
  }
}

export const [SeriesColorProvider, useSeriesColorGenerator] = constate(useSeriesColorGeneratorInternal);
